<template>
  <div class="purchase-wrapper">
    <div
      id="purchase-container"
      class="purchase-container"
    >
      <div class="purchase__header">
        <div class="purchase__title">
          Unlock Even More Insights
        </div>
        <div class="purchase__sub-title">
          Find a plan that fits your needs, or stay on the free plan
        </div>
      </div>
      <div class="purchase__select-wrapper">
        <GlSelectButton
          gray-padding="wide"
          grey
          :options="computedPlanTypes"
          :value="activeCycle"
          @input="typeChange"
        />
      </div>

      <div class="purchase-cards__wrapper">
        <div v-if="getPlansLoading">
          <gl-loader />
        </div>
        <PlanCard
          v-for="item in getPlans"
          v-else
          :key="item.id"
          :active-cycle="activeCycle"
          :item="item"
          @onBuyClick="onBuyClick"
          @onExampleClick="onExampleClick"
        />
      </div>
    </div>
  </div>
</template>

<script>
// Components
import GlLoader from '@/components/gl-loader'
import PlanCard from '@/pages/report/components/purchase/PlanCard'
import GlSelectButton from '@/components/gl-select-button2.vue'
// utils
import { openExample } from '@/utils/go-to-route'
// vuex
import { mapGetters } from 'vuex'
// Utils
import { billingCycle, getAnnualSaveDiff, getPlanOptionsWithProfit } from '@/utils/plans'

export default {
  components: { PlanCard, GlLoader, GlSelectButton },
  data() {
    return {
      activeCycle: null,
      billingCycle,
    }
  },
  computed: {
    ...mapGetters('payment', ['getPlans', 'getPlansLoading']),
    computedPlanTypes() {
      const diff = getAnnualSaveDiff(this.getPlans || [])
      return getPlanOptionsWithProfit(this.billingCycle, diff)
    },
  },
  created() {
    this.activeCycle = this.billingCycle.find(cycle => cycle.value)
  },
  methods: {
    openExample,
    onBuyClick(value) {
      this.$emit('buy-report', value)
    },
    onExampleClick(value) {
      this.openExample(value)
    },
    typeChange(type) {
      this.activeCycle = type
    },
  },
}
</script>

<style scoped>
.purchase-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
  padding-bottom: calc(var(--report-banner-height) + 24px);
}
.purchase-container {
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 48px 0;
  width: var(--main-content-width);
  max-width: var(--main-content-max-width);
}

.purchase__header {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.purchase__title {
  text-align: center;
  font-size: var(--Size-4XL, 36px);
  font-weight: 600;
  line-height: var(--Line-Height-4XL, 44px);
  letter-spacing: var(--Letter-Spacing-XS, -0.5px);
}
.purchase__sub-title {
  text-align: center;
  color: var(--Basic-800, rgba(9, 21, 64, 0.68));
  font-size: var(--Size-L, 16px);
  font-weight: 500;
  line-height: var(--Line-Height-XL, 24px);
  letter-spacing: var(--Letter-Spacing-XS, -0.5px);
}

.purchase-cards__wrapper {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 38px;
  position: relative;
  word-break: break-word;
  padding-top: 36px;
}

.purchase__select-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.purchase__select-wrapper::v-deep .gl-select-button-wrapper {
  width: auto;
}

@media (max-width: 830px) {
  .purchase-cards__wrapper {
    flex-direction: column;
    align-items: center;
    gap: 24px;
    padding-top: 0px;
  }
  .purchase-cards__wrapper .plan-card:has(.plan-card--popular-mask) {
    margin-top: 36px;
    margin-bottom: 8px;
  }
}
@media (max-width: 430px) {
  .purchase-wrapper {
    padding-right: 12px;
    padding-left: 12px;
  }
  .plan-card {
    width: 100%;
  }
}
</style>
